/**
 * agentHistory — the stored case chat, in the shape the agent renders.
 * v242.156.0 · CASE-CHAT-PERSIST-1.
 *
 * ★★★ IT IS ITS OWN MODULE, AND THAT IS WHY IT CAN BE GATED. Written inline inside the
 * zustand action it could only ever be DESCRIBED: `useAgentStore` pulls in the whole
 * services layer, so a gate importing it drags a network client behind it. Pure, with no
 * imports of its own, it is `await import`-able exactly as `utils/sessionReturn.js` is —
 * which is the pattern this repo already uses for a rule that must be executed rather
 * than read (check-session-lock.mjs, and the reason that file exists).
 *
 * The GUARDS around this — real case only, once per account, never over a live thread —
 * belong to the action, because they are about state. The SHAPE belongs here.
 */

/**
 * A stored turn (api/index.py, `case_chat_turn`) → one agent message.
 *
 * ★ An unrecognised role reads as the PATIENT, never as Orella. Of the two ways to be
 *   wrong, attributing something Orella said to the patient is the worse one: it puts
 *   words in their mouth inside their own record.
 * ★ A missing body is an empty string rather than the word "undefined" on screen, and an
 *   unparseable timestamp falls back to now rather than becoming a NaN that sorts
 *   nowhere.
 */
export function agentMessagesFromStored(turns) {
  return (Array.isArray(turns) ? turns : []).map((t) => ({
    role: t?.role === 'assistant' ? 'assistant' : 'user',
    content: t?.text || '',
    timestamp: Date.parse(t?.created_at || '') || Date.now(),
  }))
}
